import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import { PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useQuery } from "react-query";
import { GrupoUnidadeDetalheUnidadeItem } from "../typings";

function useDetalheGrupoUnidade(id: string, page: number = 1, search?: string) {
  return useQuery([`/v1/grupo-unidade/${id}-${page}-${search}`], async () => {
    const { data } = await http.get<PaginateResult<GrupoUnidadeDetalheUnidadeItem> & {nome: string}>(`/v1/grupo-unidade/${id}`, {
      params: {
        page,
        limit: BaseFiltroPaginate.Limit,
        search,
      }
    });

    return data;
  });
}

export default useDetalheGrupoUnidade;
